import { notification } from "antd";
import { NavigateFunction } from "react-router";
import { getEnvironmentService } from "../../backend";
import { trackQuickDeploy } from "../../backend/tracking/deployment";
import { trackResourceUndeployInit } from "../../backend/tracking/resource";
import { DoubleConfirmationModalProps } from "../../contexts/Modal";

interface IUndeployResourceProps {
    envId: string;
    projectId: string;
    openConfirmModal: (props: DoubleConfirmationModalProps) => void;
    navigate: NavigateFunction;
    resourceName: string;
}

export async function undeployResource({
    envId,
    projectId,
    navigate,
    resourceName,
}: Omit<IUndeployResourceProps, "openConfirmModal">) {
    try {
        trackResourceUndeployInit({ resourceName, envId });

        await getEnvironmentService().deployStage(
            envId,
            projectId,
            {
                partial: true,
                resourceVersionOverrides: {
                    [resourceName]: null as any
                }
            });
        notification.success({
            message: "Undeploy initiated",
            description: "It could take a few moments for the changes to take effect."
        });
        trackQuickDeploy(envId!);
        setTimeout(() => {
            navigate(`/projects/${projectId}/environments/${envId}/deployments`);
        }, 2000);
    } catch (error: any) {
        notification.error({
            message: "Error while trying to undeploy resource",
            description: error?.response?.data?.message ? error?.response?.data?.message : "We encountered an error while trying to undeploy this resource. Please try again."
        });
    }
}